{
  "version": 1,
  "asset_id": "3d180f4e-6a48-4caf-81f0-a24c6b2cd281",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/3d180f4e-6a48-4caf-81f0-a24c6b2cd281/sleeve-amateur-2-220.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/3d180f4e-6a48-4caf-81f0-a24c6b2cd281/sleeve-amateur-2-220.webp",
  "original_filename": "sleeve-amateur-2-220.webp",
  "size": 7016,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:15:23Z"
}
